import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { fetchData, postData } from "../../services/apiServices";
import debounce from "lodash/debounce";

const SettlementData = () => {
  const [modal, setModal] = useState(false);
  const [search, setSearch] = useState("");
  const [userType, setUserType] = useState("all");
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [newUser, setNewUser] = useState({
    email: "",
    password: "",
    username: "",
  });
  const [viewModal, setViewModal] = useState(false);
  const [selectedSettlement, setSelectedSettlement] = useState(null);

  const openViewModal = (row) => {
    setSelectedSettlement(row);
    setViewModal(true);
  };
  const columns = [
    {
      name: "User",
      cell: (row) => (
        <div>
          <div>{row.user?.username || "N/A"}</div>
          <small className="text-muted">{row.user?.phonenumber}</small>
        </div>
      ),
    },
    {
      name: "Match",
      cell: (row) => (
        <div>
          <strong>{row.match?.home_team}</strong> vs{" "}
          <strong>{row.match?.away_team}</strong>
          <div style={{ fontSize: "12px", color: "#666" }}>
            {row.match?.sport_title}
          </div>
        </div>
      ),
    },
    {
      name: "Type",
      selector: (row) => row.type,
    },
    {
      name: "Stake",
      selector: (row) => `₹${row.stake}`,
    },
    {
      name: "Result",
      cell: (row) => (
        <span
          className={`badge ${
            row.result === "win"
              ? "bg-success"
              : row.result === "loss"
                ? "bg-danger"
                : "bg-secondary"
          }`}
        >
          {row.result}
        </span>
      ),
    },
    {
      name: "Net Amount",
      selector: (row) => `₹${row.netAmount}`,
    },
    {
      name: "Settled At",
      selector: (row) => new Date(row.settledAt).toLocaleString(),
    },
    {
      name: "Action",
      cell: (row) => (
        <Button size="sm" color="info" onClick={() => openViewModal(row)}>
          View
        </Button>
      ),
    },
  ];

  const getData = async (page, searchQuery = "") => {
    setPending(true);
    try {
      // Pass search query as a parameter object
      const params = {
        page,
        limit: perPage,
        search: searchQuery,
      };

      const response = await fetchData("api/admin/settlementhistory", params);
      console.log("settlement :>> ", response);
      if (response && response.status && response.data) {
        let sortedData = response.data;
        if (searchQuery) {
          sortedData = sortedData.sort((a, b) => {
            const aUsername = (a.username || "").toLowerCase();
            const bUsername = (b.username || "").toLowerCase();
            const aEmail = (a.email || "").toLowerCase();
            const bEmail = (b.email || "").toLowerCase();
            const searchLower = searchQuery.toLowerCase();

            // Exact matches come first
            if (aUsername === searchLower || aEmail === searchLower) return -1;
            if (bUsername === searchLower || bEmail === searchLower) return 1;

            // Then starts with matches
            if (
              aUsername.startsWith(searchLower) ||
              aEmail.startsWith(searchLower)
            )
              return -1;
            if (
              bUsername.startsWith(searchLower) ||
              bEmail.startsWith(searchLower)
            )
              return 1;

            // Then includes matches
            const aIncludes =
              aUsername.includes(searchLower) || aEmail.includes(searchLower);
            const bIncludes =
              bUsername.includes(searchLower) || bEmail.includes(searchLower);
            if (aIncludes && !bIncludes) return -1;
            if (!aIncludes && bIncludes) return 1;

            return 0;
          });
        }

        setRows(sortedData);
        setTotalRows(response.pagination?.totalRecords || response.data.length);
      } else {
        setRows([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setRows([]);
      setTotalRows(0);
    } finally {
      setPending(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      getData(1, searchQuery);
      setCurrentPage(1);
    }, 300), // Reduced debounce time for better responsiveness
    [perPage],
  );

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    debouncedSearch(searchValue);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getData(page, search);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPending(true);
    setPerPage(newPerPage);
    try {
      const params = {
        page,
        limit: newPerPage,
        search,
      };
      const response = await fetchData("api/admin/getadminbankdetails", params);
      if (response && response.data) {
        setRows(response.data);
        setTotalRows(
          response.pagination?.totalAccounts || response.data.length,
        );
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getData(1, "");
  }, []);

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex gap-3 align-items-center">
            {/* <Input
              type="select"
              value={userType}
              onChange={handleUserTypeChange}
              style={{ width: "150px" }}
            >
              <option value="all">All Users</option>
              <option value="internal">Internal</option>
              <option value="external">External</option>
            </Input> */}
          </div>
          {/* <Button color="primary" onClick={toggleModal}>
            Create User
          </Button> */}
        </div>

        <DataTable
          columns={columns}
          data={rows}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          progressPending={pending}
          responsive
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 25, 30, 50, 100]}
        />
        <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg">
          <ModalHeader toggle={() => setViewModal(false)}>
            Settlement Details
          </ModalHeader>

          <ModalBody>
            {selectedSettlement && (
              <div className="container-fluid">
                <Row className="mb-2">
                  <Col md={6}>
                    <b>User Phone:</b> {selectedSettlement.user?.phonenumber}
                  </Col>
                  <Col md={6}>
                    <b>Email:</b> {selectedSettlement.user?.email || "-"}
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col md={12}>
                    <b>Match:</b> {selectedSettlement.match?.home_team} vs{" "}
                    {selectedSettlement.match?.away_team}
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col md={6}>
                    <b>Sport:</b> {selectedSettlement.match?.sport_title}
                  </Col>
                  <Col md={6}>
                    <b>Start Time:</b>{" "}
                    {new Date(
                      selectedSettlement.match?.commence_time,
                    ).toLocaleString()}
                  </Col>
                </Row>

                <hr />

                <Row className="mb-2">
                  <Col md={6}>
                    <b>Bet Type:</b> {selectedSettlement.type}
                  </Col>
                  <Col md={6}>
                    <b>Odds:</b> {selectedSettlement.odds}
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col md={6}>
                    <b>Stake:</b> ₹{selectedSettlement.stake}
                  </Col>
                  <Col md={6}>
                    <b>Commission:</b> ₹{selectedSettlement.commission}
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col md={6}>
                    <b>Profit:</b> ₹{selectedSettlement.profit}
                  </Col>
                  <Col md={6}>
                    <b>Loss:</b> ₹{selectedSettlement.loss}
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col md={6}>
                    <b>Net Amount:</b> ₹{selectedSettlement.netAmount}
                  </Col>
                  <Col md={6}>
                    <b>Result:</b> {selectedSettlement.result}
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col md={6}>
                    <b>Match Winner:</b> {selectedSettlement.matchWinner}
                  </Col>
                  <Col md={6}>
                    <b>Settled At:</b>{" "}
                    {new Date(selectedSettlement.settledAt).toLocaleString()}
                  </Col>
                </Row>
              </div>
            )}
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={() => setViewModal(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </CardBody>
    </Card>
  );
};

export { SettlementData };
